import { Directive } from '@angular/core'

@Directive({
    selector: '[tidyCardTitle]',
    standalone: false
})
export class TidyCardTitleDirective {}
